/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { jsx as _jsx } from "react/jsx-runtime";
const SvgDatagridNodata = (props) => (_jsx("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 64 64", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "ndl-icon-svg" }, props, { children: _jsx("g", { id: "custom/datagrid-nodata", children: _jsx("path", { id: "Vector", d: "M58.6668 22.3397V12.7799C58.6668 10.1509 56.5335 8 53.9261 8H10.0742C7.46683 8 5.3335 10.1509 5.3335 12.7799V22.3397M58.6668 22.3397H5.3335M58.6668 22.3397H40.889M58.6668 22.3397V35.9623M5.3335 22.3397V45.761C5.3335 48.39 7.46683 50.5409 10.0742 50.5409H23.1113M5.3335 22.3397H23.1113M23.1113 22.3397V50.5409M23.1113 22.3397H40.889M23.1113 50.5409L37.3335 50.6667M5.3335 36.6793H58.6668M40.889 22.3397V35.9623M41.6003 43.132L57.0077 58.6667M57.0077 43.132L41.6003 58.6667", stroke: "#A8ACB2", strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }) }) })));
export default SvgDatagridNodata;
//# sourceMappingURL=DatagridNodata.js.map